import serviceAxios from "../request.js";

// 获取接龙模版列表
export const getHomePageTempleList = (data) => {
  return serviceAxios({
    url: "/activity/getHomePageTempleList",
    method: "post",
    data,
  });
};

// 发布记录列表

export const getCreateList = (data) => {
  return serviceAxios({
    url: "/mine/getCreateList",
    method: "post",
    data,
  });
};

// 获取我的信息
export const getMyInfo = (data) => {
  return serviceAxios({
    url: "/mine/getMyInfo",
    method: "post",
    data,
  });
};

// 参与订单列表（我的订单）
export const getOrderList = (params) => {
  return serviceAxios({
    url: "/api/vip/order/unified/list",
    method: "get",
    params,
  });
};

// 获取小程序接龙码

export const getActivityCode = (data) => {
  return serviceAxios({
    url: "/activity/getActivityCode",
    method: "post",
    data,
  });
};

// 分享链接
export const getShareLink = (data) => {
  return serviceAxios({
    url: "/activity/getShareLink",
    method: "post",
    data,
  });
};

// 获取红包列表
export const getRedPacketList = (params) =>
  serviceAxios({
    url: "/api/redPacket/listByActivityId",
    method: "get",
    params,
  });

// 获取红包领取详情
export const getClaimDetail = (params) =>
  serviceAxios({
    url: "/api/redPacket/claim/detail",
    method: "get",
    params,
  });

// 创建红包订单（返回二维码）
export const createRedPacketOrderPc = (data) =>
  serviceAxios({
    url: "/api/redPacket/order/pc/create",
    method: "post",
    data,
  });

// 检查红包支付状态
export const checkRedPacketPaymentStatus = (params) =>
  serviceAxios({
    url: "/api/redPacket/order/pc/queryPayStatus",
    method: "get",
    params,
  });

// 提前结束

export const earlyTermination = (data) => {
  return serviceAxios({
    url: "/activity/earlyTermination",
    method: "post",
    data,
  });
};

// 重启活动

export const restartActivity = (data) => {
  return serviceAxios({
    url: "/activity/restartActivity",
    method: "post",
    data,
  });
};

// 立即开始

export const startImmediately = (data) => {
  return serviceAxios({
    url: "/activity/startImmediately",
    method: "post",
    data,
  });
};

// 删除接口

export const delActivity = (data) => {
  return serviceAxios({
    url: "/mine/delActivity",
    method: "post",
    data,
  });
};
// 获取分类
export const getFirstTempleType = (data) => {
  return serviceAxios({
    url: "/activity/getFirstTempleType",
    method: "post",
    data,
  });
};

// 获取二级分类
export const getTwoTempleType = (data) => {
  return serviceAxios({
    url: "/activity/getTwoTempleType",
    method: "post",
    data,
  });
};

// /activity/getTempleList 获取全部模版
export const getTempleList = (data) => {
  return serviceAxios({
    url: "/activity/getTempleList",
    method: "post",
    data,
  });
};

// 接龙报名列表

export const getSignList = (data) => {
  return serviceAxios({
    url: "/activity/pc/getSignList",
    method: "post",
    data,
  });
};

export const activityDetail = (data) => {
  return serviceAxios({
    url: "/activity/activityDetail",
    method: "post",
    data,
  });
};
//判断身份
export const getProjectManageAdmin = (data) => {
  return serviceAxios({
    url: "/activity/getProjectManageAdmin",
    method: "post",
    data,
  });
};
// 接龙报名列表
export const getSignListMore = (data) => {
  return serviceAxios({
    url: "/activity/getSignListMore",
    method: "post",
    data,
  });
};
//报名列表评论
export const SignListComment = (data) => {
  return serviceAxios({
    url: "/activity/SignListComment",
    method: "post",
    data,
  });
};
//报名列表评论列表
export const getSignListComment = (data) => {
  return serviceAxios({
    url: "/activity/getSignListComment",
    method: "post",
    data,
  });
};
//点评
export const updatecommentlanguage = (data) => {
  return serviceAxios({
    url: "/activity/updatecommentlanguage",
    method: "post",
    data,
  });
};
// 点赞数量
export const sleDetails = (data) => {
  return serviceAxios({
    url: "/activity/sleDetails",
    method: "post",
    data,
  });
};

//点赞
export const thumbsUp = (data) => {
  return serviceAxios({
    url: "/activity/thumbsUp",
    method: "post",
    data,
  });
};

//取消点赞

export const delthumbsUp = (data) => {
  return serviceAxios({
    url: "/activity/delthumbsUp",
    method: "post",
    data,
  });
};
//通知点赞
export const noticeThumbsUp = (data) => {
  return serviceAxios({
    url: "/activity/noticeThumbsUp",
    method: "post",
    data,
  });
};
//取消通知点赞
export const delNoticeThumbsUp = (data) => {
  return serviceAxios({
    url: "/activity/delNoticeThumbsUp",
    method: "post",
    data,
  });
};

//新增评分
export const updateScore = (data) => {
  return serviceAxios({
    url: "/activity/updateScore",
    method: "post",
    data,
  });
};
export const clockNameListByName = (data) => {
  return serviceAxios({
    url: "/activity/clockNameListByName",
    method: "post",
    data,
  });
};
//通知记录
export const getNoticeListMore = (data) => {
  return serviceAxios({
    url: "/activity/getNoticeListMore",
    method: "post",
    data,
  });
};
//删除报名
export const signDel = (data) => {
  return serviceAxios({
    url: "/activity/signDel",
    method: "post",
    data,
  });
};

// 修改报名信息接口

export const updateSignInfo = (data) => {
  return serviceAxios({
    url: "/activity/updateSignInfo",
    method: "post",
    data,
  });
};

// 不允许(允许)他人查看

export const updateSignInfoLook = (data) => {
  return serviceAxios({
    url: "/activity/updateSignInfo",
    method: "post",
    data,
  });
};

//回收站數據
export const getRecycleBin = (data) => {
  return serviceAxios({
    url: "/mine/getRecycleBin",
    method: "post",
    data,
  });
};

//回收站彻底删除数据
export const recycleBinKill = (data) => {
  return serviceAxios({
    url: "/mine/recycleBinKill",
    method: "post",
    data,
  });
};

//回收站恢复数据
export const recycleBinRestore = (data) => {
  return serviceAxios({
    url: "/mine/recycleBinRestore",
    method: "post",
    data,
  });
};

// 表格数据
export const tableAttempting = (data, timeout = 0) => {
  return serviceAxios({
    url: "/activity/tableAttempting",
    method: "post",
    data,
    timeout,
  });
};

// 统计分析
export const listAnalysis = (data, timeout = 0) => {
  return serviceAxios({
    url: "/activity/listAnalysis",
    method: "post",
    data,
  });
};

// 导出
export const listAnalysisExport = (data, timeout = 0) => {
  return serviceAxios({
    url: "/exportListByChoose/listAnalysis",
    method: "post",
    data,
    timeout,
  });
};

//导出
export const orderListByChoose = (data) => {
  return serviceAxios({
    url: "/exportListByChoose/orderListByChoose",
    method: "post",
    data,
  });
};

// 打包
export const imageAndVideoFiles = (data, timeout = 0) => {
  return serviceAxios({
    url: "/exportListByChoose/listAnalysisFiles",
    method: "post",
    data,
    timeout,
  });
};

// 获取表单项
export const activityListItems = (data) => {
  return serviceAxios({
    url: "/activity/activityListItems",
    method: "post",
    data,
  });
};

// 排行榜
export const activityRanking = (data) => {
  return serviceAxios({
    url: "/activity/activityRanking",
    method: "post",
    data,
  });
};
//删除评论
export const delSignListComment = (data) => {
  return serviceAxios({
    url: "/activity/delSignListComment",
    method: "post",
    data,
  });
};
//分享文件夹二维码
export const getFolderShareLink = (data) => {
  return serviceAxios({
    url: "/activity/getFolderShareLink",
    method: "post",
    data,
  });
};

// 清空空全部参与记录
export const delSignOrder = (data) => {
  return serviceAxios({
    url: "/activity/delSignOrder",
    method: "post",
    data,
  });
};

//添加、修改标签
export const updateTag = (data) => {
  return serviceAxios({
    url: "/tag/updateTag",
    method: "post",
    data,
  });
};

//查询标签列表
export const listTags = (data) => {
  return serviceAxios({
    url: "/tag/listTags",
    method: "post",
    data,
  });
};
export const listTagsCount = (data) => {
  return serviceAxios({
    url: "/tag/listTagsCount",
    method: "post",
    data,
  });
};

//设置报名列表标签
export const setOrderTag = (data) => {
  return serviceAxios({
    url: "/activity/pc/setOrderTag",
    method: "post",
    data,
  });
};

//删除报名列表标签
export const delTagByGroup = (data) => {
  return serviceAxios({
    url: "/activity/pc/delTagByGroup",
    method: "post",
    data,
  });
};

// 获取系统图
export const getimageUrls = (data) => {
  return serviceAxios({
    url: "/activity/getimageUrls",
    method: "post",
    data,
  });
};

// 视频token
export const getVideoPathToken = (data) => {
  return serviceAxios({
    url: "/videoTx/getVideoPathToken",
    method: "post",
    data,
  });
};

// 视频地址
export const getVideoPathUrl = (data) => {
  return serviceAxios({
    url: "/videoTx/getVideoPathUrl",
    method: "post",
    data,
  });
};

// 封面类型
export const getimageTypes = (data) => {
  return serviceAxios({
    url: "/activity/getimageTypes",
    method: "post",
    data,
  });
};
// 封面类型
export const selBrowseHistory = (data) => {
  return serviceAxios({
    url: "/activity/selBrowseHistory",
    method: "post",
    data,
  });
};
// 封面类型
export const addBrowseHistory = (data) => {
  return serviceAxios({
    url: "/activity/addBrowseHistory",
    method: "post",
    data,
  });
};

// 获取视频新的地址
export const getNewVideoPathUrl = (data) => {
  return serviceAxios({
    url: "/videoTx/getNewVideoPathUrl",
    method: "post",
    data,
  });
};

// 存储文件链接
/**
 * @param {Object} data
 * @param {String} data.linkType 导出类型 1 打包链接 2 打包文件
 * @param {Long} data.activityId 活动id
 * @param {String} data.fileUrl 链接生成地址
 * @param {String} data.screeningScope 筛选范围
 * @returns
 */
export const setFileLink = (data) =>
  serviceAxios({
    url: "/activity/setFileLink",
    method: "post",
    data,
  });

// 获取文件链接
/**
 *
 * @param {Object} data
 * @param {Long} data.activityId 活动id
 * @returns
 */
export const selFileLink = (data) =>
  serviceAxios({
    url: "/activity/selFileLink",
    method: "post",
    data,
  });

// 轮询获取文件链接
/**
 *
 * @param {Object} data
 * @param {Long} data.activityId 活动id
 * @returns
 */
export const updateTip = (data) =>
  serviceAxios({
    url: "/activity/updateTip",
    method: "post",
    data,
  });
//辅助接口
export const updateActivitySignList = (data) =>
  serviceAxios({
    url: "/activity/updateActivitySignList",
    method: "post",
    data,
  });
//判断用户是否关注过公众号
export const isFollowWechat = (data) =>
  serviceAxios({
    url: "/wechat/whetherToFollow",
    method: "post",
    data,
  });

//是否允许导出
export const allowExport = (data) =>
  serviceAxios({
    url: "/export/allowExport",
    method: "post",
    data,
  });

// 导出时间
export const exportTime = (data) =>
  serviceAxios({
    url: "/export/exportTime",
    method: "post",
    data,
  });

// 导出时间
export const exportDataValue = (data) =>
  serviceAxios({
    url: "/exportListByChoose/exportDataValue",
    method: "post",
    data,
  });

export const exportFrequency = (data) =>
  serviceAxios({
    url: "/export/exportFrequency",
    method: "post",
    data,
  });

export const ListOfPersonnelOptions = (data) =>
  serviceAxios({
    url: "/activity/ListOfPersonnelOptions",
    method: "get",
    params: data,
  });

  export const handleUnreadOrderCount = (data) =>
    serviceAxios({
      url: "/activity/handleUnreadOrderCount",
      method: "post",
      data,
    });

// 红包相关接口
// 创建红包订单
export const createRedPacketOrder = (data) =>
  serviceAxios({
    url: "/api/redPacket/order/create",
    method: "post",
    data,
  });

// 获取红包支付参数
export const getRedPacketPaymentParams = (params) =>
  serviceAxios({
    url: "/api/redPacket/order/payment/params",
    method: "get",
    params,
  });

// 计算红包价格
export const calculateRedPacketPrice = (params) =>
  serviceAxios({
    url: "/api/redPacket/order/calculate",
    method: "get",
    params,
  });

// 获取红包详情
export const getRedPacketDetail = (params) =>
  serviceAxios({
    url: "/api/redPacket/detail",
    method: "get",
    params,
  });

// 获取账户信息（待结算金额）
export const getAccountInfo = (params) =>
  serviceAxios({
    url: "/api/account/info",
    method: "get",
    params,
  });
